import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DynamicFormsService {
  constructor(
    public http: HttpClient,
  ) { }

  getForm(form_slug,caseId,debtor_id,dpa_check){
    const apiURL =  localStorage.getItem('server_url') + `b/dynamic_form_builder/dynamic_form_render/${form_slug}/${caseId}/${debtor_id}/${dpa_check}?source=debtor_API`;
    return this.http.get(apiURL);
  }

  saveFormData(form_slug,caseId,debtor_id,payload,dpa_check){
    const apiURL =  localStorage.getItem('server_url') + `b/dynamic_form_builder/dynamic_form_render/${form_slug}/${caseId}/${debtor_id}/${dpa_check}?source=debtor_API`;
    return this.http.post(apiURL,payload);
  }

  // Called only after a payment gateway confirms success, so a disclosure's
  // confirmation email (ACH or card) is never sent for a failed payment.
  // The email typed on the payment form is sent so the backend can use it in
  // place of the debtor's saved email; without it the backend falls back to the saved one.
  sendDisclosureConfirmationEmail(form_slug, caseId, email?){
    const apiURL = localStorage.getItem('server_url') + `b/dynamic_form_builder/send_disclosure_confirmation_email/${form_slug}/${caseId}?source=debtor_API`;
    return this.http.post(apiURL, email ? { email } : {});
  }
}
